<!-- Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. -->
<mat-icon (click)="toggleCollapse()">{{
	(collapsed$ | async) ? 'arrow_menu_close' : 'arrow_menu_open'
}}</mat-icon>
<ng-content></ng-content>
